import { ModalBody, ModalContent, ModalHeader } from 'ui-components';

export const UnknownStep = () => {
  return (
    <ModalContent>
      <ModalHeader>Add Talent</ModalHeader>
      <ModalBody>
        Something unexpected happened. Please contact support.
      </ModalBody>
    </ModalContent>
  );
};
